/**
 * Hook: useOMRCardGeneration
 * Manages OMR card preview state and data fetching
 */

import { useState, useCallback } from 'react';
import { API_BASE_URL } from '../services/api';

export const useOMRCardGeneration = () => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [examData, setExamData] = useState({
    examId: null,
    examName: '',
    questions: [],
    loading: false,
    error: null,
  });

  const openPreview = useCallback(async (examId, examName) => {
    setExamData((prev) => ({
      ...prev,
      loading: true,
      error: null,
    }));

    try {
      // Tenta carregar questões reais do backend
      let questions = [];

      try {
        const response = await fetch(`${API_BASE_URL}/exams/${examId}/`, {
          credentials: 'include',
        });

        if (response.ok) {
          const examDetail = await response.json();
          // Se houver questões no backend
          if (examDetail.questions && examDetail.questions.length > 0) {
            questions = examDetail.questions;
          } else if (examDetail.total_questions) {
            // Senão, cria questões mock com base no total_questions
            const count = examDetail.total_questions;
            questions = Array.from({ length: count }, (_, i) => ({
              number: i + 1,
              title: `Questão ${i + 1}`,
            }));
          }
        }
      } catch (apiError) {
        console.warn('Erro ao carregar do backend, usando mock:', apiError);
      }

      // Se ainda não tem questões, usa mock padrão de 30
      if (questions.length === 0) {
        questions = Array.from({ length: 30 }, (_, i) => ({
          number: i + 1,
          title: `Questão ${i + 1}`,
        }));
      }

      setExamData({
        examId,
        examName,
        questions,
        loading: false,
        error: null,
      });

      setIsPreviewOpen(true);
    } catch (error) {
      setExamData((prev) => ({
        ...prev,
        loading: false,
        error: error.message || 'Erro ao carregar questões',
      }));
    }
  }, []);

  const closePreview = useCallback(() => {
    setIsPreviewOpen(false);
  }, []);

  return {
    isPreviewOpen,
    examData,
    openPreview,
    closePreview,
  };
};
